/**
 * Internal Dependencies
 */
import User from './user';

let _user = false;

const userFactory = () => {
   
    if (!_user) {
        _user = new User();
    }
    return _user;
};

export default userFactory;